import { Component } from '@angular/core';
import { AuthService } from './core/auth/auth.service';
import { KeyStorage } from './core/enums';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Webmini_LandingPage';
  constructor(private authService: AuthService) {
    this.setIsLogin();
  }

  setIsLogin() {
    localStorage.setItem(
      KeyStorage.is_login,
      JSON.stringify(this.authService.hasValidToken())
    );
  }
}
